
import styled from 'styled-components';
import { SectionWithExternalContentCardProps } from './query';
import ExternalContentCard from '@/components/molecules/ExternalContentCard';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

const ExternalContentCardsContainer = styled.div`
	align-items: flex-start;
	margin-top: 3rem;
	display: flex;
	justify-content: center;
	gap: 2rem;
	/* CSS specific to macOS devices */
	@media not all and (${devices.macOS}) {
		> div {
			margin: 0 1.1rem 0 1.1rem;
		}
	}
	/* CSS specific to iOS devices */
	@supports (${devices.iOS}) {
		> div {
			margin: 2rem 0 1rem;
		}
	}
	@media screen and (${devices.mobile}) {
		align-items: center;
		flex-direction: column;
		gap: 0;
		margin: 2rem 0 1rem;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		align-items: center;
		flex-direction: column;
		gap: 0;
		margin: 2rem 0 1rem;
	}
`;

const SectionWithExternalContentCard = ({
	sectionWithExternalContentCardData,
}: {
	sectionWithExternalContentCardData: SectionWithExternalContentCardProps,
}) => {
	return (
		<>
			<Title_v2
				align={sectionWithExternalContentCardData.title.alignedAt}
				underlineColor={sectionWithExternalContentCardData.title.underlineColor}
			>
				{renderUnderline(sectionWithExternalContentCardData.title.titlePieces)}
			</Title_v2>
			{sectionWithExternalContentCardData.description && (
				<Text textAlign='center'>
					{sectionWithExternalContentCardData.description}
				</Text>
			)}
			<ExternalContentCardsContainer>
				{sectionWithExternalContentCardData.cards.map(
					(card, index) => (
						<ExternalContentCard
							content={card}
							key={index}
						/>
					),
				)}
			</ExternalContentCardsContainer>
		</>
	);
};

export default SectionWithExternalContentCard;
